export const footerPages = {
  disclaimer: {
    path: '/disclaimer',
    label: 'Disclaimer',
    eyebrow: 'Legal',
    title: 'Disclaimer',
    intro:
      'The information provided on Metameni’s website, social media platforms, blogs, and product pages is intended for general informational and educational purposes only.',
    sections: [
      {
        heading: 'Individual results may vary',
        body: [
          'Skincare results can vary from person to person depending on skin type, lifestyle, existing skin conditions, consistency of product usage, and environmental factors.',
          'Metameni does not guarantee identical results for every individual.',
        ],
      },
      {
        heading: 'Not medical advice',
        body: [
          'Our products and content are not intended to diagnose, treat, cure, or prevent any medical condition or disease. Customers with severe skin conditions, allergies, or medical concerns are advised to consult a qualified dermatologist before using any skincare product.',
        ],
      },
      {
        heading: 'Patch test recommendation',
        body: [
          'We strongly recommend performing a patch test before using any new skincare product.',
        ],
      },
      {
        heading: 'Ingredient transparency',
        body: [
          'While we strive to provide accurate ingredient information, formulations may occasionally be updated or modified. Customers are encouraged to read product labels carefully before use.',
        ],
      },
      {
        heading: 'External links',
        body: [
          'Our website may contain links to third-party websites or platforms. Metameni is not responsible for the content, policies, or practices of external websites.',
        ],
      },
      {
        heading: 'Limitation of liability',
        body: [
          'Metameni shall not be held responsible for allergic reactions, improper product usage, misuse of products, customer negligence, or indirect or incidental damages arising from product usage.',
          'By using our website and purchasing our products, you acknowledge and agree to this disclaimer.',
        ],
      },
    ],
  },
  privacy: {
    path: '/privacy-notice',
    label: 'Privacy Notice',
    eyebrow: 'Legal',
    title: 'Privacy Notice',
    intro:
      'At Metameni, protecting your privacy and personal information is extremely important to us. This Privacy Notice explains how we collect, use, store, and protect your information when you use our website or purchase our products.',
    sections: [
      {
        heading: 'Information we collect',
        items: [
          'Name',
          'Phone number',
          'Email address',
          'Shipping and billing address',
          'Payment details (processed securely through payment gateways)',
          'Device and browser information',
          'Website usage data',
        ],
      },
      {
        heading: 'How we use your information',
        items: [
          'Processing orders',
          'Delivering products',
          'Customer support',
          'Sending order updates',
          'Improving website experience',
          'Marketing and promotional communication (with consent)',
          'Fraud prevention and security',
        ],
      },
      {
        heading: 'Payment security',
        body: [
          'All online payments are processed through secure third-party payment gateways. Metameni does not store complete credit/debit card information.',
        ],
      },
      {
        heading: 'Data protection',
        body: [
          'We take reasonable technical and organizational measures to protect your personal data from unauthorized access, misuse, loss, or disclosure.',
        ],
      },
      {
        heading: 'Cookies',
        body: [
          'Our website may use cookies to improve website functionality, remember customer preferences, analyze website performance, and personalize user experience. Customers can disable cookies through browser settings if preferred.',
        ],
      },
      {
        heading: 'Third-party services',
        body: [
          'We may share limited information with trusted third-party service providers such as shipping partners, payment gateways, analytics tools, and marketing platforms. These services are required for operational purposes only.',
        ],
      },
      {
        heading: 'Marketing communication',
        body: [
          'Customers may receive promotional emails or SMS regarding product launches, offers, educational content, and updates. Customers can unsubscribe from marketing communication anytime.',
        ],
      },
      {
        heading: 'Children’s privacy',
        body: [
          'Metameni does not knowingly collect personal information from individuals under the age of 18 without parental consent.',
        ],
      },
      {
        heading: 'Policy updates',
        body: [
          'Metameni reserves the right to update this Privacy Notice at any time without prior notice.',
          'For privacy-related concerns, contact: hello@metameni.com',
        ],
      },
    ],
  },
  terms: {
    path: '/terms-and-conditions',
    label: 'Terms & Conditions',
    eyebrow: 'Legal',
    title: 'Terms & Conditions',
    intro:
      'Welcome to Metameni. By accessing or using our website, you agree to comply with the following Terms & Conditions. Please read them carefully before using our services.',
    sections: [
      {
        heading: 'Website usage',
        body: [
          'By using this website, you confirm that you are legally capable of entering into binding agreements, the information provided by you is accurate, and you will not misuse the website or its services.',
        ],
      },
      {
        heading: 'Product information',
        body: [
          'We strive to ensure that all product descriptions, images, prices, and ingredient details are accurate. However, minor variations or errors may occasionally occur.',
          'Metameni reserves the right to modify product information, update pricing, discontinue products, or change formulations without prior notice.',
        ],
      },
      {
        heading: 'Intellectual property',
        body: [
          'All content on this website including logos, product images, graphics, text, branding, and website design is the intellectual property of Metameni and may not be copied, reproduced, or used without written permission.',
        ],
      },
      {
        heading: 'Orders & cancellations',
        body: [
          'Metameni reserves the right to accept or reject orders, cancel suspicious transactions, and refuse service to customers violating policies.',
          'Orders can only be cancelled before shipment.',
        ],
      },
      {
        heading: 'Limitation of liability',
        items: [
          'Indirect damages',
          'Delayed deliveries',
          'Technical interruptions',
          'Allergic reactions caused by undisclosed sensitivities',
          'Customer misuse of products',
        ],
        body: [
          'Metameni shall not be liable for the above circumstances where applicable.',
        ],
      },
      {
        heading: 'External links',
        body: [
          'The website may contain links to third-party websites. Metameni is not responsible for third-party content or practices.',
        ],
      },
      {
        heading: 'Governing law',
        body: [
          'These Terms & Conditions shall be governed by and interpreted under the laws of India.',
          'Metameni reserves the right to update or modify these terms at any time without prior notice.',
          'For legal queries, contact: hello@metameni.com',
        ],
      },
    ],
  },
  grievances: {
    path: '/grievances',
    label: 'Grievances',
    eyebrow: 'Support',
    title: 'Grievance Redressal',
    intro:
      'At Metameni, customer satisfaction and transparency are extremely important to us. We are committed to addressing customer concerns in a fair, timely, and professional manner.',
    sections: [
      {
        heading: 'What we can help with',
        items: [
          'Orders',
          'Payments',
          'Product quality',
          'Refunds',
          'Privacy',
          'Website usage',
          'Customer service',
        ],
        body: [
          'If you have any complaints, grievances, or concerns regarding the above, you may contact our Grievance Officer through the details provided below.',
        ],
      },
      {
        heading: 'Customer support & grievance officer',
        body: [
          'Metameni Labs Pvt Ltd',
          'Mohammad Adil',
          'Email: hello@metameni.com',
          'Phone: +91 9412064060',
        ],
      },
      {
        heading: 'Response timeline',
        body: [
          'We aim to acknowledge customer grievances within 48 business hours and resolve issues as quickly as possible.',
        ],
      },
      {
        heading: 'Required information',
        items: [
          'Full name',
          'Order ID (if applicable)',
          'Registered email or mobile number',
          'Detailed description of the concern',
          'Supporting images or documents if necessary',
        ],
      },
      {
        heading: 'Resolution process',
        items: [
          'Review the complaint',
          'Verify relevant details',
          'Communicate updates',
          'Provide a suitable resolution',
        ],
        body: [
          'Metameni values customer trust and continuously works to improve customer experience through transparent communication and responsible support.',
        ],
      },
    ],
  },
  'track-order': {
    path: '/track-order',
    label: 'Track & Order',
    eyebrow: 'Orders',
    title: 'Track Your Order',
    intro:
      'Thank you for shopping with Metameni. We are committed to delivering your orders safely and efficiently across India.',
    sections: [
      {
        heading: 'Order processing',
        body: [
          'All orders are processed within 24–48 business hours after successful payment confirmation. Orders placed on weekends or public holidays may be processed on the next working day.',
        ],
      },
      {
        heading: 'Estimated delivery timelines',
        items: [
          'Metro Cities: 2–5 business days',
          'Other Cities & Towns: 4–7 business days',
          'Remote Locations: 5–10 business days',
        ],
      },
      {
        heading: 'Order tracking',
        body: [
          'Once your order is shipped, you will receive a tracking link via email or SMS to monitor your shipment status in real time.',
          'For faster support, please include your order ID while contacting us regarding existing orders.',
        ],
      },
      {
        heading: 'Delivery delays',
        body: [
          'Delivery timelines may occasionally be affected due to weather conditions, courier partner delays, public holidays, high order volumes, or unforeseen logistical issues.',
        ],
      },
      {
        heading: 'Need help?',
        body: [
          'For shipping-related assistance, contact us at hello@metameni.com',
        ],
      },
    ],
  },
  returns: {
    path: '/returns-refunds',
    label: 'Return & Refund Policies',
    eyebrow: 'Policies',
    title: 'Return & Refund Policy',
    intro:
      'At Metameni, customer satisfaction is important to us. We carefully inspect all products before dispatch. However, if you receive a damaged, defective, or incorrect product, we are here to help.',
    sections: [
      {
        heading: 'Eligibility for returns',
        items: [
          'Product received is damaged',
          'Product received is defective',
          'Wrong product delivered',
        ],
      },
      {
        heading: 'Return request timeline',
        body: [
          'Customers must raise a return request within 7 days of receiving the order.',
        ],
      },
      {
        heading: 'Non-returnable conditions',
        body: [
          'For hygiene and safety reasons, we do not accept returns for opened products, used products, products damaged after delivery, or change of mind or personal preference.',
        ],
      },
      {
        heading: 'How to request a return',
        items: [
          'Email us at hello@metameni.com',
          'Mention your order ID',
          'Attach clear photos/videos of the issue',
          'Our team will review your request within 48 hours',
        ],
      },
      {
        heading: 'Refund process',
        body: [
          'Once the return is approved and verified, refunds will be processed within 5–7 business days through the original payment method.',
          'For Cash on Delivery orders, refund details may be collected separately.',
        ],
      },
      {
        heading: 'Cancellation policy',
        body: [
          'Orders can only be cancelled before they are shipped.',
          'Metameni reserves the right to refuse returns that do not meet our return policy conditions.',
        ],
      },
    ],
  },
  payments: {
    path: '/payments-policy',
    label: 'Payments Policy',
    eyebrow: 'Policies',
    title: 'Payment Policy',
    intro:
      'At Metameni, we aim to provide a safe, secure, and seamless payment experience for all our customers.',
    sections: [
      {
        heading: 'Accepted payment methods',
        items: [
          'UPI Payments',
          'Credit Cards',
          'Debit Cards',
          'Net Banking',
          'Wallet Payments',
          'Cash on Delivery (COD) for eligible locations',
        ],
      },
      {
        heading: 'Secure transactions',
        body: [
          'All payments made on Metameni are processed through secure and encrypted payment gateways. We do not store your complete card details, banking credentials, or sensitive payment information on our servers.',
        ],
      },
      {
        heading: 'Payment confirmation',
        body: [
          'Once a payment is successfully completed, customers will receive order confirmation via email or SMS, payment acknowledgment, and order details and invoice confirmation.',
        ],
      },
      {
        heading: 'Failed transactions',
        body: [
          'In case your payment fails but the amount is deducted from your account, the amount is usually automatically reversed by your bank within 5–7 business days.',
          'If the issue persists, please contact your bank or payment provider first. You may also contact our support team for assistance.',
        ],
      },
      {
        heading: 'Cash on delivery (COD)',
        body: [
          'COD services may be available only for selected pin codes and order values. Metameni reserves the right to disable COD for certain products, locations, or suspicious orders.',
        ],
      },
      {
        heading: 'Pricing & taxes',
        body: [
          'All product prices listed on the website are inclusive of applicable taxes unless otherwise mentioned. Prices are subject to change without prior notice.',
        ],
      },
      {
        heading: 'Fraud prevention',
        body: [
          'Metameni reserves the right to cancel or hold orders suspected of fraudulent activity, unauthorized transactions, or misuse of payment systems.',
        ],
      },
      {
        heading: 'Refund payments',
        body: [
          'Approved refunds will be processed through the original payment method used during purchase. Refund timelines may vary depending on banking partners and payment gateways.',
          'For payment-related support, contact: hello@metameni.com',
        ],
      },
    ],
  },
  shipping: {
    path: '/shipping',
    label: 'Shipping Info',
    eyebrow: 'Policies',
    title: 'Shipping Policy',
    intro:
      'Thank you for shopping with Metameni. We are committed to delivering your orders safely and efficiently across India. Please read our shipping policy carefully to understand how orders are processed and shipped.',
    sections: [
      {
        heading: 'Order processing',
        body: [
          'All orders are processed within 24–48 business hours after successful payment confirmation. Orders placed on weekends or public holidays may be processed on the next working day.',
        ],
      },
      {
        heading: 'Shipping timeline',
        body: [
          'Estimated delivery timelines may vary depending on your location.',
        ],
        items: [
          'Metro Cities: 2–5 business days',
          'Other Cities & Towns: 4–7 business days',
          'Remote Locations: 5–10 business days',
        ],
      },
      {
        heading: 'Shipping charges',
        items: [
          'Free shipping may be available on selected prepaid orders and promotional offers.',
          'Shipping charges, if applicable, will be displayed during checkout.',
        ],
      },
      {
        heading: 'Order tracking',
        body: [
          'Once your order is shipped, you will receive a tracking link via email or SMS to monitor your shipment status in real time.',
        ],
      },
      {
        heading: 'Delivery delays',
        items: [
          'Weather conditions',
          'Courier partner delays',
          'Public holidays',
          'High order volumes',
          'Unforeseen logistical issues',
        ],
        body: [
          'Delivery timelines may occasionally be affected due to the factors listed above.',
        ],
      },
      {
        heading: 'Cash on delivery',
        body: [
          'Cash on Delivery (COD) may be available for selected locations.',
        ],
      },
      {
        heading: 'Incorrect address',
        body: [
          'Please ensure that your shipping address and contact information are accurate while placing your order. Metameni will not be responsible for delays or delivery failures caused by incorrect information.',
        ],
      },
      {
        heading: 'Damaged packages',
        body: [
          'If you receive a damaged package, please contact us within 24 hours of delivery along with clear images of the package and product.',
          'For shipping-related assistance, contact us at: hello@metameni.com',
        ],
      },
    ],
  },
  faqs: {
    path: '/faqs',
    label: 'FAQs',
    eyebrow: 'Help',
    title: 'FAQs',
    intro:
      'Frequently asked questions about Metameni products, orders, and skincare.',
    sections: [
      {
        heading: 'Is Metameni suitable for all skin types?',
        body: [
          'Metameni products are formulated to suit a wide range of skin types including oily, combination, and acne-prone skin. However, we recommend patch testing before use.',
        ],
      },
      {
        heading: 'Are your products dermatologically tested?',
        body: [
          'Our formulations are developed with carefully researched ingredients and safety-focused standards. Product testing standards may vary depending on the formulation.',
        ],
      },
      {
        heading: 'How long does shipping take?',
        body: [
          'Orders are generally delivered within 3–7 business days depending on your location.',
        ],
      },
      {
        heading: 'Do you offer Cash on Delivery?',
        body: [
          'Yes, COD may be available for selected locations and eligible orders.',
        ],
      },
      {
        heading: 'Can I return opened products?',
        body: [
          'For hygiene and safety reasons, opened or used products cannot be returned unless damaged or defective.',
        ],
      },
      {
        heading: 'Are your products fragrance free?',
        body: [
          'Many of our formulations are developed without added fragrance to minimize unnecessary irritation.',
        ],
      },
      {
        heading: 'Can I use multiple active ingredients together?',
        body: [
          'Some active ingredients can be combined safely while others should be used carefully. We recommend checking product usage instructions or consulting a skincare professional.',
        ],
      },
      {
        heading: 'How can I contact customer support?',
        body: [
          'You can contact us through: hello@metameni.com',
        ],
      },
      {
        heading: 'Are your products cruelty free?',
        body: [
          'Metameni does not support animal testing practices.',
        ],
      },
      {
        heading: 'How should I store skincare products?',
        body: [
          'Store products in a cool, dry place away from direct sunlight and excessive heat.',
        ],
      },
    ],
  },
};

export const overviewLinks = [
  { label: 'About Us', path: '/about' },
  { label: footerPages.disclaimer.label, path: footerPages.disclaimer.path },
  { label: footerPages.privacy.label, path: footerPages.privacy.path },
  { label: footerPages.terms.label, path: footerPages.terms.path },
  { label: footerPages.grievances.label, path: footerPages.grievances.path },
];

export const quickLinks = [
  { label: footerPages['track-order'].label, path: footerPages['track-order'].path },
  { label: footerPages.returns.label, path: footerPages.returns.path },
  { label: footerPages.payments.label, path: footerPages.payments.path },
  { label: footerPages.shipping.label, path: footerPages.shipping.path },
  { label: footerPages.faqs.label, path: footerPages.faqs.path },
  { label: 'Blogs', path: '/blog' },
];
